import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'

import { FaCheck, FaPlus } from 'react-icons/fa'
import { IoIosArrowForward } from "react-icons/io"
import { checkStatus } from '../../component/helpers/helperVehicle'
import { useTranslation } from 'react-i18next'

const TreeGroupNode = (props) => {
	const { group, onTreeGroupNodeClick } = props
	const { groupName, devices, collapsed, statuses } = group
	const { t } = useTranslation();

	return (
		<button
			className={`category-item flex-item thin ${!collapsed && 'expanded'}`}
			onClick={() => onTreeGroupNodeClick(group)}
		>
			<div>
				{`${groupName === 'null' ? t('homePage.treeGroupNode.nullGroup') : checkStatus(groupName)} (${devices.length})`}
				<div className="group-statuses status-row">
					{statuses.driving > 0 && <><div className="icon driving" /><span>{statuses.driving}</span></>}
					{statuses.parked > 0 && <><div className="icon parked" /><span>{statuses.parked}</span></>}
					{statuses.idling > 0 && <><div className="icon idling" /><span>{statuses.idling}</span></>}
					{statuses.offline > 0 && <><div className="icon offline" /><span>{statuses.offline}</span></>}
					{statuses.disabled > 0 && <><div className="icon disabled" /><span>{statuses.disabled}</span></>}
					{statuses.sleep > 0 && <><div className="icon sleep" /><span>{statuses.sleep}</span></>}
					{statuses.awake > 0 && <><div className="icon awake" /><span>{statuses.awake}</span></>}
					{statuses['pending sleep'] > 0 && <><div className="icon pending_sleep" /><span>{statuses['pending sleep']}</span></>}
					{statuses['pending awake'] > 0 && <><div className="icon pending_awake" /><span>{statuses['pending awake']}</span></>}
					{statuses['non-vehicle'] > 0 && <><div className="icon non-vehicle" /><span>{statuses['non-vehicle']}</span></>}
				</div>
			</div>
			<IoIosArrowForward />
		</button>
	)
}

export default TreeGroupNode;
